var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 22,
    viewBox: "0 0 39 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 37,
    height: 22,
    rx: 5,
    fill: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0898 7.41797C13.0898 8.83594 14.0391 10.2188 15.6211 10.7695L15.0117 11.6367C13.8633 11.1973 13.0078 10.3301 12.5625 9.23438C12.1055 10.4531 11.209 11.4141 9.97266 11.8828L9.375 11.0039C11.0039 10.418 11.9766 8.96484 11.9883 7.38281V6.14062H13.0898V7.41797ZM18.1406 5.50781V13.3359H17.0273V8.8125H14.8125V7.89844H17.0273V5.50781H18.1406ZM18.375 14.8711V15.7734H11.2852V12.457H12.4102V14.8711H18.375ZM24.293 6.24609V7.14844H21.2578V8.32031H24.1758V9.17578H21.2578V10.4531C22.6641 10.4414 23.5898 10.3887 24.668 10.1836L24.7734 11.0977C23.543 11.332 22.5469 11.3789 20.8711 11.3672H20.1914V6.24609H24.293ZM28.7109 5.50781V11.8828H27.6562V9.08203H26.3672V11.8008H25.3242V5.69531H26.3672V8.17969H27.6562V5.50781H28.7109ZM28.7109 12.3867V15.9961H27.6094V13.2891H21.5742V12.3867H28.7109Z",
    fill: "#74737C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.ec4fea4d8bc3cb6780a2fc6246ef29df.svg";
export { ForwardRef as ReactComponent };